module.exports = __webpack_public_path__ + "img/banner.21457676.jpg";